<div class="container service-state-container">
  <div class="row">
    <div class="col-md-7 states-left">
      <ul class="states-card">
        <li *ngFor="let state of states">
          <a
            class="states-card__body"
            routerLink="/services"
            [queryParams]="{ stateId: state.stateId }"
          >
            <ng-container [ngSwitch]="state.stateId">
              <span
                class="svg-col"
                *ngSwitchCase="'2'"
                [innerHTML]="maharashtraStateSVG | safeHTML"
              ></span>
              <span
                class="svg-col"
                *ngSwitchCase="'10'"
                [innerHTML]="gujaratStateSVG | safeHTML"
              ></span>
              <span
                class="svg-col"
                *ngSwitchCase="'20'"
                [innerHTML]="haryanaStateSVG | safeHTML"
              ></span>
              <span
                class="svg-col"
                *ngSwitchCase="'30'"
                [innerHTML]="delhiStateSVG | safeHTML"
              ></span>
            </ng-container>

            <h5 class="mb-0">{{ state.stateName | translate }}</h5>
          </a>
        </li>
      </ul>
    </div>
    <div class="col-md-5 states-right">
      <div class="main-heading">
        {{ "states-section.services-by-states" | translate }}
      </div>
      <p>
        {{ "states-section.states-section-desc" | translate }}
      </p>
      <a class="btn btn-primary" routerLink="/services">{{
        "buttons.explore-states" | translate
      }}</a>
    </div>
  </div>
</div>
